// extracted by mini-css-extract-plugin
module.exports = {"tokenomincList":"Tokenomincs_tokenomincList__2Dwxu","circle":"Tokenomincs_circle__z7Shg","dots":"Tokenomincs_dots__1Swl7"};